import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import Footer, { WhatsAppButton } from "@/components/Footer";
import { AuthCallback, Protected } from "@/components/Auth";
import { ForcePasswordChange } from "@/components/PasswordAuth";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderPage from "@/pages/OrderPage";
import Journal from "@/pages/Journal";
import PostPage from "@/pages/PostPage";
import About from "@/pages/About";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import WarrantyCheck from "@/pages/WarrantyCheck";
import VerifyCertificate from "@/pages/VerifyCertificate";
import Account from "@/pages/Account";
import Learn from "@/pages/Learn";
import PromoPage from "@/pages/PromoPage";
import Admin from "@/pages/admin/Admin";

function useTracking() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    let vid = localStorage.getItem("ce_vid");
    if (!vid) { vid = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("ce_vid", vid); }
    api.post("/track", { path: location.pathname, visitor_id: vid }).catch(() => {});
    window.scrollTo(0, 0);
  }, [location.pathname]);
}

function Shell({ children }) {
  return (<><Header /><main className="min-h-[60vh]">{children}</main><Footer /><WhatsAppButton /></>);
}

function AppRouter() {
  const location = useLocation();
  useTracking();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/admin/*" element={<Protected roles={["superadmin", "staff"]}><Admin /></Protected>} />
      <Route path="/learn/:productId" element={<Protected><Learn /></Protected>} />
      <Route path="*" element={
        <Shell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order/:orderId" element={<OrderPage />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<PostPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/promo/:code" element={<PromoPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/warranty" element={<WarrantyCheck />} />
            <Route path="/warranty/:serial" element={<WarrantyCheck />} />
            <Route path="/verify/certificate/:id" element={<VerifyCertificate />} />
            <Route path="/account" element={<Protected><Account /></Protected>} />
          </Routes>
        </Shell>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRouter />
        <ForcePasswordChange />
        <Toaster position="top-center" />
      </BrowserRouter>
    </AppProvider>
  );
}
